<template>
  <div>
    <base-button v-if="isAdding"
                 ref="btnEl"
                 id="add-source-button"
                 variant="bordered-error"
                 icon="close"
                 icon-size="1.2rem"
                 class="h-11 items-center"
                 @click="handleAddSource"
    >
      Cancel
    </base-button>

    <dropdown-button v-else
                     ref="btnEl"
                     name="add-source-btn"
                     :options="options"
                     close-on-select
                     use-teleport
                     dropdown-button-variant="dropdown-no-description"
                     reverse-option-content
                     primary-button-variant="primary"
                     @select-button="handleAddSource"
    >
      <template #label>
        <base-icon icon="add" size="1.2rem" class="mr-2"/>
         Add source
      </template>
    </dropdown-button>
  </div>
</template>

<script>
import DropdownButton from '@/components/common/DropdownButton'
import BaseIcon from '@/components/base-components/BaseIcon'
import BaseButton from '@/components/base-components/BaseButton'
import dropdownButtonsUtils from '@/utils/dropdown-button.utils'
import is from 'ramda/src/is'

export default {
  name: 'SettingsIndexesAddSourceButton',

  components: {
    BaseIcon,
    DropdownButton,
    BaseButton
  },

  props: {
    isAdding: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {}
  },

  computed: {
    options() {
      return dropdownButtonsUtils.getAddKBSourceOptions()
    }
  },

  methods: {
    handleAddSource(optIndex) {
      const sourceType = is(Number, optIndex) ? this.options[optIndex].key : null
      this.$emit('add-source', { sourceType, el: this.$refs.btnEl.$el })
    }
  }
}
</script>
